import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import ru from './languages/ru/common.json'
import en from './languages/en/common.json'
import ruProfile from './languages/ru/profile.json'
import enProfile from './languages/en/profile.json'
import ruRoles from './languages/ru/roles.json'
import enRoles from './languages/en/roles.json'
import ruOrders from './languages/ru/orders.json'
import enOrders from './languages/en/orders.json'
import ruTickets from './languages/ru/tickets.json'
import enTickets from './languages/en/tickets.json'
import ruKits from './languages/ru/kits.json'
import enKits from './languages/en/kits.json'
import ruReturns from './languages/ru/returns.json'
import enReturns from './languages/en/returns.json'
import ruReports from './languages/ru/reports.json'
import enReports from './languages/en/reports.json'
import ruCustomers from './languages/ru/customers.json'
import enCustomers from './languages/en/customers.json'
import ruFbo from './languages/ru/fbo.json'
import enFbo from './languages/en/fbo.json'
import ruAbandoned from './languages/ru/abandoned.json'
import enAbandoned from './languages/en/abandoned.json'
import ruProducts from './languages/ru/products.json'
import enProducts from './languages/en/products.json'
import ruOptions from './languages/ru/options.json'
import enOptions from './languages/en/options.json'
import ruMaterials from './languages/ru/materials.json'
import enMaterials from './languages/en/materials.json'
import ruFeatures from './languages/ru/features.json'
import enFeatures from './languages/en/features.json'
import ruReviews from './languages/ru/reviews.json'
import enReviews from './languages/en/reviews.json'
import ruBadges from './languages/ru/badges.json'
import enBadges from './languages/en/badges.json'
import ruKvants from './languages/ru/kvants.json'
import enKvants from './languages/en/kvants.json'
import ruBrands from './languages/ru/brands.json'
import enBrands from './languages/en/brands.json'
import ruShipping from './languages/ru/shipping.json'
import enShipping from './languages/en/shipping.json'
import ruStores from './languages/ru/stores.json'
import enStores from './languages/en/stores.json'
import ruWarehouse from './languages/ru/warehouse.json'
import enWarehouse from './languages/en/warehouse.json'
import ruAssembly from './languages/ru/assembly.json'
import enAssembly from './languages/en/assembly.json'
import ruInventory from './languages/ru/inventory.json'
import enInventory from './languages/en/inventory.json'
import ruAutopurchases from './languages/ru/autopurchases.json'
import enAutopurchases from './languages/en/autopurchases.json'
import ruPurchase from './languages/ru/purchase.json'
import enPurchase from './languages/en/purchase.json'
import ruActivity from './languages/ru/activity.json'
import enActivity from './languages/en/activity.json'
import ruBlog from './languages/ru/blog.json'
import enBlog from './languages/en/blog.json'
import ruDelivery from './languages/ru/delivery.json'
import enDelivery from './languages/en/delivery.json'
import ruMarketing from './languages/ru/marketing.json'
import enMarketing from './languages/en/marketing.json'
import ruCosting from './languages/ru/costing.json'
import enCosting from './languages/en/costing.json'
import ruDashboard from './languages/ru/dashboard.json'
import enDashboard from './languages/en/dashboard.json'

i18n

  .use(LanguageDetector)

  .use(initReactI18next)

  .init({
    debug: false,
    fallbackLng: 'ru',
    defaultNS: 'common',
    ns: [
      'common',
      'profile',
      'roles',
      'orders',
      'tickets',
      'kits',
      'returns',
      'reports',
      'customers',
      'fbo',
      'abandoned',
      'products',
      'options',
      'materials',
      'features',
      'reviews',
      'badges',
      'kvants',
      'brands',
      'shipping',
      'stores',
      'warehouse',
      'assembly',
      'inventory',
      'autopurchases',
      'purchase',
      'activity',
      'blog',
      'delivery',
      'marketing',
      'costing',
      'dashboard',
    ],
    fallbackNS: [
      'profile',
      'roles',
      'orders',
      'tickets',
      'kits',
      'returns',
      'reports',
      'customers',
      'fbo',
      'abandoned',
      'products',
      'options',
      'materials',
      'features',
      'reviews',
      'badges',
      'kvants',
      'brands',
      'shipping',
      'stores',
      'warehouse',
      'assembly',
      'inventory',
      'autopurchases',
      'purchase',
      'activity',
      'blog',
      'delivery',
      'marketing',
      'costing',
      'dashboard',
    ],
    lng: localStorage.getItem('i18nextLng') || 'ru',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      ru: {
        common: ru.translation,
        profile: ruProfile,
        roles: ruRoles,
        orders: ruOrders,
        tickets: ruTickets,
        kits: ruKits,
        returns: ruReturns,
        reports: ruReports,
        customers: ruCustomers,
        fbo: ruFbo,
        abandoned: ruAbandoned,
        products: ruProducts,
        options: ruOptions,
        materials: ruMaterials,
        features: ruFeatures,
        reviews: ruReviews,
        badges: ruBadges,
        kvants: ruKvants,
        brands: ruBrands,
        shipping: ruShipping,
        stores: ruStores,
        warehouse: ruWarehouse,
        assembly: ruAssembly,
        inventory: ruInventory,
        autopurchases: ruAutopurchases,
        purchase: ruPurchase,
        activity: ruActivity,
        blog: ruBlog,
        delivery: ruDelivery,
        marketing: ruMarketing,
        costing: ruCosting,
        dashboard: ruDashboard,
      },
      en: {
        common: en.translation,
        profile: enProfile,
        roles: enRoles,
        orders: enOrders,
        tickets: enTickets,
        kits: enKits,
        returns: enReturns,
        reports: enReports,
        customers: enCustomers,
        fbo: enFbo,
        abandoned: enAbandoned,
        products: enProducts,
        options: enOptions,
        materials: enMaterials,
        features: enFeatures,
        reviews: enReviews,
        badges: enBadges,
        kvants: enKvants,
        brands: enBrands,
        shipping: enShipping,
        stores: enStores,
        warehouse: enWarehouse,
        assembly: enAssembly,
        inventory: enInventory,
        autopurchases: enAutopurchases,
        purchase: enPurchase,
        activity: enActivity,
        blog: enBlog,
        delivery: enDelivery,
        marketing: enMarketing,
        costing: enCosting,
        dashboard: enDashboard,
      },
    },
  })

export default i18n
